module.exports = __webpack_public_path__ + "img/1095one2.15fe3cb7.png";